/* 核心必备的工具或方法 */
import '@ms/utils/registerServiceworker'
import '@ms/utils/reset'
import './style/main.css'
import Vue from 'vue'
import VDialog from 'fe-vui/dialog'
import 'base/icons'
import 'wap/directive/block-loading'
import 'wap/directive/loading'
import './style/base.less'
import '@ms/utils/visibilitychange.js'
import '@ms/utils/css.js'

Vue.use(VDialog)
